import { useMemo } from "react";
import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import { bankAccount } from "@/hooks/firestore/models/bankAccount";

const useBankAccounts = () => {
  const {
    data: bankAccounts,
    isLoading,
    error,
  } = useFirestore("/users/{userId}/bankAccounts", bankAccount.array());

  return {
    isLoading,
    bankAccounts,
    error,
  };
};

const useBankAccount = () => {
  const { bankAccounts, error, isLoading } = useBankAccounts();

  const bankAccount = useMemo(
    () => (bankAccounts || []).find((account) => account.active),
    [bankAccounts],
  );

  return { bankAccount, isLoading, error };
};

type BankAccount = Exclude<
  ReturnType<typeof useBankAccount>["bankAccount"],
  undefined
>;

export { useBankAccounts, useBankAccount };
export type { BankAccount };
